const getIsAssistedSalesEnabled = configuration =>
  configuration?.app?.assistedSales?.enabled ?? true;

const getIsAssistedSalesDisabledPopinEnabled = configuration =>
  configuration?.app?.assistedSales?.disabledPopin ?? false;

/**
 * Assisted sales can be switched off per market in general, while still being
 * enabled for the salesmen listed in 'enabledForSalesmen' (case-insensitive).
 */
const getIsAssistedSalesEnabledForSalesman = (configuration, salesman) => {
  if (getIsAssistedSalesEnabled(configuration)) {
    return true;
  }

  if (typeof salesman !== "string" || !salesman) {
    return false;
  }

  const enabledForSalesmen =
    configuration?.app?.assistedSales?.enabledForSalesmen ?? [];

  return enabledForSalesmen.some(
    enabledSalesman => enabledSalesman.toLowerCase() === salesman.toLowerCase()
  );
};

module.exports = {
  getIsAssistedSalesEnabled,
  getIsAssistedSalesDisabledPopinEnabled,
  getIsAssistedSalesEnabledForSalesman,
};
